import { RouterModule, Routes } from '@angular/router';

import { TranslationsGuard } from '@ui/legacy-lib';

import { NgModule } from '@angular/core';
import { LogoutComponent } from 'landlord/auth/components/logout/logout.component';
import {
  SidebarNotAuthenticatedComponent,
  FullscreenNotAuthenticatedComponent
} from '../layouts';

import { AuthGuard, LoginPageGuard } from './guards';

import {
  AuthComponent,
  VerifyEmailComponent,
  RequestPasswordResetComponent,
  ResetPasswordComponent,
  ConfirmEmailComponent
} from './components';

export const ROUTES: Routes = [
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: 'email-verification',
    component: VerifyEmailComponent,
    canActivate: [TranslationsGuard]
  },
  {
    path: 'confirm-new-email',
    component: ConfirmEmailComponent,
    canActivate: [TranslationsGuard]
  },
  {
    path: 'reset-password',
    canActivate: [TranslationsGuard],
    component: SidebarNotAuthenticatedComponent,
    children: [
      {
        path: '',
        component: ResetPasswordComponent
      },
      {
        path: 'request-reset',
        component: RequestPasswordResetComponent
      }
    ]
  },
  {
    path: 'register',
    canActivate: [TranslationsGuard],
    component: FullscreenNotAuthenticatedComponent,
    loadChildren: () =>
      import('landlord/auth/register/register.module').then(
        module => module.RegisterModule
      )
  },
  {
    path: 'login',
    canActivate: [TranslationsGuard, LoginPageGuard],
    component: SidebarNotAuthenticatedComponent,
    loadChildren: () =>
      import('landlord/auth/login/login.module').then(
        module => module.LoginModule
      ),
    data: {
      title: 'PAGE_LOGIN_1'
    }
  },
  {
    path: 'logout',
    canActivate: [AuthGuard],
    component: LogoutComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
